// Copyright 2025, University of Maryland, All Rights Reserved
//
// Application auto-discovery using Vite's import.meta.glob.
//
// Automatically discovers and imports all register.ts files
// in the applications directory tree.

const registerModules = import.meta.glob('./**/register.ts', { eager: true })

export const DISCOVERED_APPLICATIONS = Object.keys(registerModules).map((path) =>
  path.replace(/^\.\//, '').replace(/\/register\.ts$/, '')
)

if (import.meta.env.DEV) {
  console.debug(`[applications] Discovered ${DISCOVERED_APPLICATIONS.length} applications:`, DISCOVERED_APPLICATIONS)
}
